/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RedeemActivationCodeBody
 */
export interface RedeemActivationCodeBody {
    /**
     * The promo code to redeem
     * @type {string}
     * @memberof RedeemActivationCodeBody
     */
    code: string;
    /**
     * The objective ID (objectiveTemplateId) within the activation
     * @type {string}
     * @memberof RedeemActivationCodeBody
     */
    objectiveId: string;
}

/**
 * Check if a given object implements the RedeemActivationCodeBody interface.
 */
export function instanceOfRedeemActivationCodeBody(value: object): value is RedeemActivationCodeBody {
    if (!('code' in value) || value['code'] === undefined) return false;
    if (!('objectiveId' in value) || value['objectiveId'] === undefined) return false;
    return true;
}

export function RedeemActivationCodeBodyFromJSON(json: any): RedeemActivationCodeBody {
    return RedeemActivationCodeBodyFromJSONTyped(json, false);
}

export function RedeemActivationCodeBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): RedeemActivationCodeBody {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'],
        'objectiveId': json['objectiveId'],
    };
}

export function RedeemActivationCodeBodyToJSON(json: any): RedeemActivationCodeBody {
    return RedeemActivationCodeBodyToJSONTyped(json, false);
}

export function RedeemActivationCodeBodyToJSONTyped(value?: RedeemActivationCodeBody | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'objectiveId': value['objectiveId'],
    };
}

